import React from 'react'
import { UsersTable } from './components/Users'

function UsersIndex() {
  return <UsersTable />
}

export { UsersIndex }
